import { combineReducers } from 'redux'

import { OPEN_LK_MODAL, CLOSE_LK_MODAL } from '../features/shared/LKModal/actions'

function openedModals(state = [], action) {
  switch (action.type) {
    case OPEN_LK_MODAL: {
      return [...state, action.payload.name]
    }
    case CLOSE_LK_MODAL: {
      return state.filter((name) => name !== action.payload.name)
    }
    default: {
      return state
    }
  }
}

export default combineReducers({
  openedModals,
})
